import { Component, effect, EventEmitter, inject, input, Input, isDevMode, Output, Signal, ViewChild } from '@angular/core';
import { StripeService, StripePaymentElementComponent, injectStripe, StripeCardComponent, StripeCardNumberComponent, NgxStripeModule } from 'ngx-stripe';
import { StripeElementsOptions, PaymentIntent, StripeCardElementOptions, PaymentMethodCreateParams, CreatePaymentMethodCustomerBalanceData, CreatePaymentMethodData } from '@stripe/stripe-js';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment.development';
import { CurrencyPipe } from '@angular/common';
import { StripeServiceAngular } from '../../service/stripe.service';
import { EnviaService } from '../../service/envia.service';
import { Store } from '@ngxs/store';
import { CartActions } from '../../state/cart.actions';
import { CartState } from '../../state/cart.state';
import { AuthActions } from '../../state/auth.actions';
import { AuthState } from '../../state/auth.state';
import { GoogleAnalyticsService } from '@hakimio/ngx-google-analytics';
import { FormShippingUserComponent } from '../form-shipping-user/form-shipping-user.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faSpinner } from '@fortawesome/pro-duotone-svg-icons';
import { faFedex, faStripe } from '@fortawesome/free-brands-svg-icons';
// FIXME Borrar este documento queda absoleto
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@Component({
  selector: 'app-stripe',
  imports: [NgxStripeModule, TranslateModule, CurrencyPipe, ReactiveFormsModule, FormShippingUserComponent, FontAwesomeModule],
  templateUrl: './stripe.component.html',
  styleUrl: './stripe.component.scss',
  standalone: true
})
export class StripeComponent {
  // @ViewChild(StripePaymentElementComponent) paymentElement: StripePaymentElementComponent;
  private readonly gaService = inject(GoogleAnalyticsService);
  @ViewChild(StripeCardNumberComponent) card!: StripeCardNumberComponent;
  @Input() tags: any;
  @Input() price_product: any;
  @Output() isCompletePayment: EventEmitter<any> = new EventEmitter<any>();
  @Output() isDelete: EventEmitter<any> = new EventEmitter<any>();

  iconSpinner = faSpinner;
  iconFedex = faFedex;
  iconStripe = faStripe;

  emailLogin: Signal<any>;
  product: string[] = [];
  qtyProduct = input<number>(1);
  qty: any = 1;
  total = 0;
  rateSelected: any;
  listRate: any = [];
  stripe = injectStripe(environment.stripe.token);
  carrierObj = {
    origin: {
      name: 'EToy Republic',
      company: 'etoyrepublic',
      email: 'contact@etoyrepublic.shop',
      phone: '5555012528',
      street: 'Emiliano Zapata',
      number: '174',
      district: 'other',
      city: 'CDMX',
      state: 'CMX',
      country: 'MX',
      postalCode: '15290',
      reference: '',
    },
    destination: {},
    packages: [
      {
        content: 'Art Toys',
        amount: 1,
        type: 'box',
        weight: 2,
        insurance: 0,
        declaredValue: 0,
        weightUnit: 'KG',
        lengthUnit: 'CM',
        dimensions: {
          length: 27,
          width: 27,
          height: 15,
        },
      },
    ],
    shipment: {
      carrier: 'fedex',
      type: 1,
    },
    settings: {
      currency: 'MXN',
    },
  };

  soldOut = false;
  successPaymentMessage = false;
  isLoad = false;
  loadingToken = false;
  erroStripe = false;
  listCountries: any = [];
  listStates: any = [];
  message: any;
  _pi: string = '';
  async ngOnDestroy() { }

  elementsOptions: StripeElementsOptions = {
    locale: 'es',
    currency: 'mxn',
  };
  cardOptions: StripeCardElementOptions = {
    style: {
      base: {
        // backgroundColor:'white',
        padding: '10px 5px 10px 5px',
        iconColor: '#666EE8',
        color: '#31325F',
        fontWeight: '300',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSize: '18px',
        '::placeholder': {
          color: '#31325F',
        },
      },
      invalid: {
        iconColor: '#ffc7ee',
        color: '#f01e21',
      },
    },
  };
  stripeTest: FormGroup;
  stripeCardForm: FormGroup;
  paying = false;
  // product = [];
  idUser = '';
  listProduct: any = {};
  button = false;
  shippingSelect = false;
  paymenSelect = false;
  billing = true;

  stock = 0;

  listNameProduct = '';

  constructor(
    private fb: FormBuilder,
    private stService: StripeServiceAngular,
    private enviaServices: EnviaService,
    private store: Store,
  ) {
    // this.paymentElement.fetchUpdates()
    this.emailLogin = this.store.selectSignal(AuthState.getDataUser);

    if (this.emailLogin()?.address !== undefined && this.emailLogin()?.address.length > 0) {
      this.emailLogin().address.forEach((element) => {
        if (element.default) {
          this.enviaServices.getStates(element.country).subscribe((res) => {
            this.listStates = res.data;
          });
          this.stripeTest = this.fb.group({
            first_name: [element.first_name, [Validators.required]],
            last_name: [element.last_name, [Validators.required]],
            email: [this.emailLogin().email, [Validators.required, Validators.email]],
            street: [element.street, [Validators.required]],
            number: [element.number, [Validators.required]],
            postalCode: [element.postalCode, [Validators.required]],
            phone: [element.phone, [Validators.required]],
            rfc: [element.rfc, [Validators.required]],
            district: [element.district, [Validators.required]],
            country: [element.country, [Validators.required]],
            state: [element.state],
            city: [element.city, [Validators.required]],
            reference: [element.reference],
          });
          this.stripeCardForm = this.fb.group({
            name: [element.name, [Validators.required]],
            email: [this.emailLogin().email, [Validators.required, Validators.email]],
          });
        }
      });
    } else {
      this.stripeTest = this.fb.group({
        first_name: ['', [Validators.required]],
        last_name: ['', [Validators.required]],
        email: ['', [Validators.required, Validators.email]],
        street: ['', [Validators.required]],
        number: ['', [Validators.required]],
        postalCode: ['', [Validators.required]],
        phone: ['', [Validators.required]],
        rfc: ['', [Validators.required]],
        district: ['', [Validators.required]],
        country: ['', [Validators.required]],
        state: [''],
        city: ['', [Validators.required]],
        reference: [''],
      });
      this.stripeCardForm = this.fb.group({
        name: ['', [Validators.required]],
        email: ['', [Validators.required, Validators.email]],
      });
    }
    // if (isDevMode() || this.emailLogin() === 'rikimm88@gmail.com') {
    //   this.stripeTest = this.fb.group({
    //     first_name: ['Ricardo', [Validators.required]],
    //     last_name: ['Moisen', [Validators.required]],
    //     email: ['rikimm88@gmail.com', [Validators.required]],
    //     street: ['Emiliano Zapata Q 202', [Validators.required]],
    //     number: ['174', [Validators.required]],
    //     postalCode: ['15290', [Validators.required]],
    //     phone: ['5555012528', [Validators.required]],
    //     rfc: ['MOMR880217Iv1', [Validators.required]],
    //     district: ['10 de mayo', [Validators.required]],
    //     country: ['', [Validators.required]],
    //     state: [''],
    //     city: ['CDMX', [Validators.required]],
    //     reference: ['']
    //   });
    //   this.stripeCardForm = this.fb.group({
    //     name: ['Ricardo Moisen', [Validators.required]],
    //     email: ['rikimm88@gmail.com', [Validators.required, Validators.email]]
    //   });
    // } else {
    //   this.stripeTest = this.fb.group({
    //     first_name: ['', [Validators.required]],
    //     last_name: ['', [Validators.required]],
    //     email: ['', [Validators.required]],
    //     street: ['', [Validators.required]],
    //     number: ['', [Validators.required]],
    //     postalCode: ['', [Validators.required]],
    //     phone: ['', [Validators.required]],
    //     rfc: ['', [Validators.required]],
    //     district: ['', [Validators.required]],
    //     country: ['', [Validators.required]],
    //     state: [''],
    //     city: ['', [Validators.required]],
    //     reference: ['']
    //   });
    //   this.stripeCardForm = this.fb.group({
    //     name: ['', [Validators.required]],
    //     email: ['', [Validators.required, Validators.email]]
    //   });
    // }
    // effect(() => {
    //   
    //   this.qty = this.qtyProduct() * this.price_product;
    //   
    // });
  }
  ngOnChanges(): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
  }

  ngOnInit(): void {
    // this.qty = Number(this.qtyProduct() * this.price_product);

    this.store.select(CartState.getList).subscribe((res) => {
      res.forEach((element) => {
        this.qty += element.price * element.stock;
        this.listNameProduct += `${element.name}, `;
        this.product.push(element);
        // this.priceTotal = this.priceSubtotal;
      });

    });

    this.enviaServices.getCountries().subscribe((res) => {
      this.listCountries = res.data;
    });


  }
  createToken(amount = this.qty) {

    this.loadingToken = true;
    this.erroStripe = false;
    const name = `${this.stripeCardForm?.get('first_name')?.value} ${this.stripeCardForm?.get('last_name')?.value} `;
    const user = {
      name: `${this.stripeTest?.get('first_name')?.value} ${this.stripeTest?.get('last_name')?.value} `,
      address_line1: `${this.stripeTest?.get('street')?.value}`,
      address_zip: `${this.stripeTest?.get('postalCode')?.value}`,
      address_state: this.listStates.find((f: any) => f.code_3_digits === this.stripeTest?.get('state')?.value).name,
      address_country: `${this.stripeTest?.get('country')?.value}`,
      city: `${this.stripeTest?.get('city')?.value}`,
    };

    let _pm: string = '';


    this.stripe.createToken(this.card.element, user).subscribe((result) => {
      this.gaService.event('payment', {
        category: 'success_token',
        label: 'Token',
      });

      // result.token?.id

      if (result.hasOwnProperty('token')) {
        const methodPayment: CreatePaymentMethodData = {
          type: 'card',
          card: {
            token: result?.token?.id!,
          },
        };
        this.stripe.createPaymentMethod(methodPayment).subscribe((res) => {

          _pm = res?.paymentMethod?.id!;

          this.createPaymentIntent(amount, _pm);
        });
      } else if (result.error) {
        // Error creating the token

        this.message = result.error.message;
      }
    });
  }
  private createPaymentIntent(amount: number = 20000, _pm: string) {
    Number(this.qty);
    this.stService
      .createPaymentIntent({ amount, description: this.listNameProduct, client: { customer_email: this.stripeTest.get('email')?.value, customer_name: `${this.stripeTest.value.first_name} ${this.stripeTest.value.last_name} ` } })
      .subscribe((res) => {
        // this.elementsOptions.clientSecret = res?.paymentIntent.client_secret!;

        this._pi = res.paymentIntent.id;

        localStorage.setItem('stripe_client', `${res?.paymentIntent.client_secret}`);
        this.store.dispatch(new CartActions.SetTokenStripe(res?.paymentIntent.client_secret!));
        //

        this.confirmPaymentIntent(_pm, this._pi);
      });
  }
  private updatePaymentIntent(amount: number, _pi: string) {
    Number(this.qty);
    this.stService
      .updatePaymentIntent({ amount, description: this.listNameProduct, client: { customer_email: this.stripeTest.get('email')?.value, customer_name: `${this.stripeTest.value.first_name} ${this.stripeTest.value.last_name} ` } })
      .subscribe((res) => {
        // this.elementsOptions.clientSecret = res?.paymentIntent.client_secret!;

        this._pi = res.paymentIntent.id;

        localStorage.setItem('stripe_client', `${res?.paymentIntent.client_secret}`);
        //

        // this.confirmPaymentIntent(_pm, this._pi)
      });
  }
  confirmPaymentIntent(_pm: string, _pi: string) {


    const obj = {
      client: _pi,
      method: _pm,
      email: this.stripeTest.get('email')?.value,
      product: this.product,
      user: this.stripeTest.value,
      rate: this.rateSelected,
      // qty: this.qtyProduct()
    };


    // this.isLoad = true;
    this.stService.postConfirmIntentPayment(obj).subscribe(
      (res) => {

        this.gaService.event('payment', {
          category: 'success_payment',
          label: 'Payment',
        });
        this.isLoad = false;

        this.message = res;
        this.loadingToken = false;
        if (res.success) {
          this.successPaymentMessage = true;
          this.erroStripe = false;
          this.store.dispatch(new CartActions.Reset());
          this.isCompletePayment.emit(true);
        }
        if (res?.stripError!) {
          this.successPaymentMessage = false;
          this.erroStripe = true;
        }
      },
      (err) => {
        this.loadingToken = false;
        this.erroStripe = true;
        this.isLoad = false;
      },
    );
  }
  selectCountry(pais: any) {
    this.enviaServices.getStates(pais.value).subscribe((res) => {
      this.listStates = res.data;
    });
  }
  calculateShipping() {
    if (this.stripeTest.invalid) {
      // FIXME de otra forma este tipo de error
      // Swal.fire({
      //   icon: 'error',
      //   text: 'Campos invalidos.',
      // });

      return false;
    }


    this.shippingSelect = true;
    Object.assign(this.carrierObj.destination, this.stripeTest.value);
    Object.assign(this.carrierObj.destination, { name: `${this.stripeTest.value.first_name} ${this.stripeTest.value.last_name} ` });
    this.isLoad = true;
    this.billing = false;
    this.enviaServices.getShippingRates(this.carrierObj).subscribe((res) => {

      this.isLoad = false;

      this.listRate = res?.body?.data;
    });
    return true;
  }
  selectRate(value: any) {

    this.isLoad = true;

    this.shippingSelect = false;
    let rate: any = {};
    if (Number.isInteger(value)) {

      Object.assign(rate, { totalPrice: 0, carrier: 'drop_store', carrierId: 3 });
    } else {
      rate = this.listRate.find((f: any) => f.service === value);
    }

    const preShippingCost = +rate.totalPrice * 1.05;
    this.rateSelected = rate;
    this.qty += rate.totalPrice * 1.05;



    if (Number.isInteger(this.qty)) {
      this.qty = this.qty.toString() + '00';
    } else {
      const split = this.qty.toString().split('.');
      let decimal = '';
      if (split[1].length === 1) {
        decimal = `0${split[1]}`;
      } else {
        decimal = split[1];
      }

      this.qty = `${split[0]}${decimal}`;
    }

    this.store.dispatch(new CartActions.SetShipping(+preShippingCost));
    this.paymenSelect = true;

    this.isLoad = false;

    this.isDelete.emit(false);
    return true;

    // this.createPaymentIntent(this.price_product);
  }
}
